<style scoped>
#search_filter {
	padding: 10px;
	min-height: 100%;
}
</style>

<template>
	<div id="search_filter">
		<v-alert type="error" v-if="errormsg != ''">{{
			errormsg
		}}</v-alert>

		<div class="text-center mb-1">
			<span>───</span>
			<span class="mx-3">Search Criteria</span>
			<span>───</span>
		</div>
		<v-form @submit.prevent="do_search">
			<!--<v-expansion-panels multiple :value="[ 0 ]">-->
			<v-expansion-panels :value="0">
				<v-expansion-panel>
					<v-expansion-panel-header v-slot="{ open }" expand-icon="">
						<v-row no-gutters>
							<v-col cols="12">
								<v-btn block class="text-capitalize">Name, Type</v-btn>
							</v-col>
							<v-col cols="12">
								<v-fade-transition leave-absolute>
									<div v-if="!open" class="mt-2">
										<div v-if="search.name != ''">
											<span>Name contains </span>
											<span class="font-weight-bold">{{ search.name }}</span>
										</div>
										<div v-if="search.abook_types.length > 0">
											<span>Address book type is </span>
											<span v-for="(abooktype, index) in search.abook_types" :key="abooktype">
												<span v-if="index > 0 && index < search.abook_types.length -1">, </span>
												<span v-if="index == search.abook_types.length -1"> or </span>
												<span class="font-weight-bold">{{ abooktype_desc(abooktype) }}</span>
											</span>
										</div>									
									</div>
								</v-fade-transition>
							</v-col>
						</v-row>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-text-field
							v-model="search.name"
							label="Name"
							hint="Name contains"
							filled dense
						/>
						<v-select
							label="Address book types"
							v-model="search.abook_types"
							:items="abook_types"
							item-text="desc"
							item-value="id"
							filled multiple dense hide-details
						>
							<template v-slot:selection="{ item, index }">
								<v-chip v-if="index <= 1"> 
									<span>{{ item.desc }}</span>
								</v-chip>
								<span
									v-if="index === 2"
									class="grey--text caption"
								>
									(+{{ search.abook_types.length - 2 }} others)
								</span>
							</template>
						</v-select>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<div class="text-center mt-2">
				<v-btn color="primary" type="submit" class="text-capitalize">Search</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
export default {
	model: {
		prop: "search",
		event: "on_change"
	},
	props: {
		search: {
			type: Object,
			default: null
		},
	},
	data() {
		return {
			errormsg: '',
			abook_types: [],
		}
	},
	created() {
		this.load_meta_data()
	},
	methods: {
		load_meta_data() {

			let self = this; // make sure we can access this inside of our promisses
			this.errormsg = '';

			axios
				.get("/api/addressbook/meta", {
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json)

						// get types
						self.abook_types = json.data.addressbook_types;
						self.abook_types.sort(function(a,b) {
							if (a.desc < b.desc) {
								return -1;
							} else if (a.desc > b.desc) {
								return 1;
							} else {
								return 0;
							}
						});
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				});
		},
		abooktype_desc(id) {
			for (let i = 0; i < this.abook_types.length; i++) {
				if (this.abook_types[i].id == id) {
					return this.abook_types[i].desc
				}
			}

			return "???"
		},
		do_on_change(new_val) {
			this.$emit('on_change', new_val)
		},
		do_search() {
			this.$emit('on_search')			
		},
	},
}

</script>
